import { HttpErrorResponse } from '@angular/common/http';

export const apiErrorMessage = (error: HttpErrorResponse): { errorMessage: string } => {
  switch (error.status) {
    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    case 401:
      return {
        errorMessage: 'Unauthorized request. Most probably you are not logged in or your session has expired. Try to reload the page.',
      };
    default:
      return { errorMessage: error.error?.message || error.statusText };
  }
};
